import { Component, Vue, Watch, PropSync } from 'vue-property-decorator';
import { EventStore } from '@/store/store.event';
import { TableHeaderItem } from '@/models/tables/TableHeaderItem';
import { DexieDataSetEvent } from '@/models/dexie/UnsyncedDexieDataSet';
import { UnsyncedTableItem } from '@/models/tables/UnsyncedTableItem';

import { DataSetEventTypeEnums } from '@/enums/DataSetEventTypeEnums';
import { LoggerService } from '@/utils';
import { DataSetService, EventsService } from '@/services/index';

import StatusInfo from './statusInfo/StatusInfo';
import { DataSetBase } from '@/models/dataset/DataSetBase';
import { DataSet } from '@/models/dataset/DataSet';
import { EventErrorResponse } from '@/models/event/eventErrorResponse';

@Component({
    components: {
        StatusInfo,
    },
})
export default class UnsyncedListComponent extends Vue {
    @PropSync('show', { type: Boolean }) public syncedShow!: boolean;

    public unsyncedEvents: DexieDataSetEvent[] = [];
    public tableItems: UnsyncedTableItem[] = [];

    public selectedEventStatus: string = '';
    public selectedEventStatusCode: number = 0;
    public selectedEventStatusInfo: EventErrorResponse = new EventErrorResponse();
    public selectedEventData: DataSetBase = new DataSetBase();
    public showInfo: boolean = false;

    // tslint:disable-next-line: no-empty
    public mounted() {
        this.unsyncedEvents = this.getUnsyncedEvents;
    }

    public updated() {
        this.unsyncedEvents = this.getUnsyncedEvents;
        this.generateTableItems();
    }

    get getUnsyncedEvents() {
        return EventStore.unsyncedEvents;
    }

    @Watch('getUnsyncedEvents', { deep: true })
    public onUnsyncedEventsChanged(newValue: DexieDataSetEvent[]) {
        this.unsyncedEvents = newValue;
        this.generateTableItems();
    }

    public close() {
        const self = this;
        this.$nextTick(() => {
            self.syncedShow = false;
        });
    }

    public onItemEdit(inTableItem: UnsyncedTableItem) {
        LoggerService.LogDebug(`onItemEdit: ${inTableItem.id}`, inTableItem);

        switch (inTableItem.eventType) {
            case DataSetEventTypeEnums.CREATE_MYMILL:
                this.$router.push(`myMillWizard/unsynced/${inTableItem.id}`);
                break;
            case DataSetEventTypeEnums.CREATE:
            case DataSetEventTypeEnums.UPDATE:
                this.$router.push(`edit/unsynced/${inTableItem.id}`);
                break;

            default:
                break;
        }
    }

    public onItemDelete(id: number) {
        EventsService.deleteUnsyncedEventById(id)
            .then(() => {
                this.unsyncedEvents = this.getUnsyncedEvents;
                this.generateTableItems();
            })
            .catch((error) => {
                LoggerService.error(`Error on deleting unsynced event: `, error);
            });
    }

    public showRequestInfo(tableItem: UnsyncedTableItem) {
        const item = this.unsyncedEvents.find((us) => us.id === tableItem.id);
        if (item !== undefined) {
            this.selectedEventStatus = tableItem.icon;
            this.selectedEventStatusCode = item.eventStatusCode || 0;
            this.selectedEventStatusInfo = new EventErrorResponse(JSON.parse(item.eventStatusInfo || ''));
            this.selectedEventData = item.dataSet;
            this.showInfo = true;
        } else {
            this.selectedEventStatus = '';
            this.selectedEventStatusInfo = new EventErrorResponse();
            this.selectedEventData = new DataSetBase();
            this.selectedEventStatusCode = 0;
        }
    }

    private generateTableItems() {
        this.tableItems.splice(0, this.tableItems.length);
        if (this.unsyncedEvents.length > 0) {
            for (const event of this.unsyncedEvents) {
                let oldDataSet;
                if (event.event === DataSetEventTypeEnums.UPDATE && event.dataSet.id != null) {
                    oldDataSet = event.previousDataSet != null
                        ? DataSetService.CloneDataSet(event.previousDataSet as DataSet)
                        : DataSetService.GetAllDataSets().find((ds) => ds.id === event.dataSet.id);
                }
                const item = UnsyncedTableItem.fromUnsyncedDexieDataSet(event, oldDataSet);
                this.tableItems.push(item);
            }
        }
    }
}
